import { useEffect, useState } from "react";
import { X, Play } from "lucide-react";
import { gallery } from "@/data/profile";

export const Gallery = () => {
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!active) return;
    const onKey = (e) => e.key === "Escape" && setActive(null);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [active]);

  return (
    <section className="section section-alt" id="gallery">
      <div className="container">
        <p className="eyebrow">07 · Life Gallery</p>
        <h2 className="section-title">Moments that shaped the journey</h2>
        <div className="gallery-grid" data-testid="gallery-grid">
          {gallery.map((item) => (
            <figure
              key={item.id}
              className={`gallery-item ${item.wide ? "gallery-wide" : ""}`}
              onClick={() => setActive(item)}
              data-testid={`gallery-item-${item.id}`}
            >
              <img src={item.type === "video" ? item.poster : item.src} alt={item.caption} loading="lazy" />
              {item.type === "video" && (
                <span className="play-badge" data-testid={`gallery-play-${item.id}`}>
                  <Play size={18} fill="currentColor" />
                </span>
              )}
              <figcaption className="gallery-overlay">
                <span className="gallery-tag">{item.tag}</span>
                <span className="gallery-caption">{item.caption}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
      {active && (
        <div className="lightbox" onClick={() => setActive(null)} data-testid="gallery-lightbox">
          <button className="lightbox-close" data-testid="gallery-lightbox-close" aria-label="Close">
            <X size={22} />
          </button>
          {active.type === "video" ? (
            <video
              src={active.src}
              poster={active.poster}
              controls
              autoPlay
              playsInline
              onClick={(e) => e.stopPropagation()}
              data-testid="gallery-lightbox-video"
            />
          ) : (
            <img src={active.src} alt={active.caption} />
          )}
          <p className="lightbox-caption">
            <span className="gallery-tag">{active.tag}</span> {active.caption}
          </p>
        </div>
      )}
    </section>
  );
};
